import React from 'react'

import {DownloadAppForm} from '../templates';
import {PageTemplate} from '../atoms';

export default function DownloadAppPage() {
  return (
    <PageTemplate>
      <DownloadAppForm />
    </PageTemplate>
  )
}
